import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable()

export class UserService {
	USER_URI: string = environment.apiUrl + '/user';

	constructor(private httpClient: HttpClient) {}

	public getAll = () => {
		return this.httpClient.get(this.USER_URI + '/all');
	}

	public getByClientAndRole = (body) => {
		return this.httpClient.post(this.USER_URI + '/client/users/role', body);
	}
	
	public create = (body) => {
		return this.httpClient.post(this.USER_URI, body);
	}

	public update = (body) => {
		return this.httpClient.put(this.USER_URI, body);
	}

	public updateOther = (body) => {
		return this.httpClient.put(this.USER_URI + "/update", body);
	}

	public isLoggedIn(): Observable<boolean> {
		let loggedIn;
		if (localStorage.getItem('user') !== null) {
			loggedIn = true;
		} else {
			loggedIn = false;
		}

		return loggedIn;
	}
	
	public getToken() {
    let user = JSON.parse(localStorage.getItem('user'));
    let token = user.token;
    return token;
	}
	
	public getUsersByRole(body) {
		return this.httpClient.post(this.USER_URI + '/client/users/role', body);
	}

	public getUsersByClient(body) {
		return this.httpClient.post(this.USER_URI + '/client/users', body);
	}

	public updateSoundNotificationUsers(body) {
		return this.httpClient.put(this.USER_URI + '/updateSoundNotification', body);
	}

}


// WEBPACK FOOTER //
// ./src/app/services/user.service.ts